__turbopack_context__.v({
  "lottie-con": "genericLoader-module-scss-module__IeC-oa__lottie-con",
  "main-con": "genericLoader-module-scss-module__IeC-oa__main-con",
});
